import React, { Component } from 'react';
import PropTypes from 'prop-types';

import StepperManager, {StepPropTypes} from '../StepperManager';
import { alertDialog } from '../../util/dialogs';
import AmpStepSourceForm from '../AmpStepSourceForm';
import AmpStepSettings from '../AmpStepSettings';
import AmpStepResults from '../AmpStepResults';
import AmpStepProcessing from '../AmpStepProcessing';
import AmpStepExport from '../AmpStepExport';

const standardErr = "If this problem persists, please contact Screen6 support.";

const styles = {
  stepperModule: {
    width: '100%',
    maxWidth: 1352,
    margin: 'auto',
    position: 'relative',
  },
}

/**
 * Configure the StepperManager component by adding Steps (StepperManager.stepperContentProvider)
 */
class AmplifyStepper extends Component {
  static contextTypes = {
    history: PropTypes.object.isRequired,
  }

  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  }

  constructor(props, context) {
    super(props, context);
    // if location.state is defined, we need to take this and override the defaults with its values
    // (to continue where we left off)
    this.state = Object.assign({
      initialStepIndex: 0,
      stepIndex: 0,
      sessionHash: '',
    }, props.location.state);
  }

  handleStartOverClicked = () =>
    this.context.history.push(`/amp/restart`);

  handleStepIndexChange = (stepIndex) =>
    this.setState({stepIndex});

  render() {
    const stepDescriptions = [
      'Select source data',
      'Configure',
      'Processing',
      'View results',
      'Export & download',
    ];

    const onlyShowOnFirstStep = {
      display: this.state.stepIndex === 0 ? 'block' : 'none',
    };

    return (
      <div style={styles.stepperModule}>
        <div className="PageHeading">
          <h1>Audience Amplification Service</h1>
          <p style={onlyShowOnFirstStep}>
            Follow the steps in this wizard to amplify your audience using the Screen6 graph for the selected dataset.
          </p>
        </div>
        <StepperManager
          initialStepIndex={this.state.initialStepIndex}
          sessionHash={this.state.sessionHash}
          onStartOverClicked={this.handleStartOverClicked}
          onStepIndexChange={this.handleStepIndexChange}
          stepperContentProvider={AmpSteps}
          stepDescriptions={stepDescriptions}
        />
      </div>
    );
  }
}

const AmpSteps = ({stepIndex, onRefChange, onValidationChange, sessionHash, onHashChange, onNextStepFail, proceedAction, goBackAction}) => {
  switch (stepIndex) {
    case 0:
      return (
        <AmpStepSourceForm
          ref={ onRefChange }
          onValidationChange={ onValidationChange }
          onStepCompleteSuccess={
            uploadResponse => {
              onHashChange(uploadResponse.data);
              proceedAction();
            }
          }
          onStepCompleteFailed={ error => {
            onNextStepFail(error);
            alertDialog(
              standardErr +
              "\nThe amplifier supports CSV files, gzipped or plain, stored as UTF-8."
            );
          }}
        />
      );
    case 1:
      return (
        <AmpStepSettings
          ref={ onRefChange }
          onValidationChange={ onValidationChange }
          hash={ sessionHash }
          onStepCompleteSuccess={ proceedAction }
          onStepCompleteFailed={
            error => {
              onNextStepFail(error);
              alertDialog(standardErr);
            }
          }
        />
      );
    case 2:
      return (
        <AmpStepProcessing
          ref={ onRefChange }
          hash={ sessionHash }
          onValidationChange={ onValidationChange }
          onStepCompleteSuccess={ proceedAction }
          onStepCompleteFailed={
            error => {
              onNextStepFail(error);
              alertDialog(standardErr);
              goBackAction();
            }
          }
        />
      );
    case 3:
      return (
        <AmpStepResults
          ref={ onRefChange }
          hash={ sessionHash }
          onValidationChange={ onValidationChange }
        />
      );
    // Show the same content on the 4th and 5th step to show the checkmark when the export is finished.
    case 4:
    case 5:
      return (
        <AmpStepExport
          ref={ onRefChange }
          hash={ sessionHash }
          onStepCompleteSuccess={ proceedAction }
        />
      );
    default:
      return 'You\'re a long way from home sonny jim!';
  }
}
AmpSteps.propTypes = StepPropTypes;

export default AmplifyStepper;



// WEBPACK FOOTER //
// ./src/components/AmpStepper/index.jsx